export const it = {
    'ROLE_FILTER.LABEL': 'Filtra ruoli',
    'ROLE_FILTER.SHOW_ALL': 'Mostra tutti i ruoli',
    'ROLE_FILTER.ELEVATED': 'Ruoli elevati',
    'ROLE_FILTER.ROLE_COUNT': '{[{ count }]} ruoli',
    'ROLE_FILTER.SELECT_ALL': 'Seleziona tutti i ruoli',
    'ROLE_FILTER.SELECT_ELEVATED': 'Seleziona i ruoli elevati',
    'ROLE_FILTER.CLEAR': 'Cancella selezione',
    'ROLES.ADMIN': 'Amministratore',
    'ROLES.REPORTER': 'Autore di report',
    'ROLES.VR_USER': 'Utente VR',
    'ROLES.EVENT_MANAGER': 'Responsabile eventi',
    'ROLES.EVENT_CURATOR': "Curatore dell'Evento",
    'ROLES.BC_USER': 'Utente BC',
    'ROLES.BC_MANAGER': 'Responsabile BC',
    'ROLES.DA_USER': 'Utente DA',
    'ROLES.DA_MANAGER': 'Responsabile DA',
    'ROLES.LR_USER': 'Utente LR',
};
